<div class="db-add-website-migrate-only">
  <div class="db-migrate-only__back" *ngIf="hasBackButton">
    <div (click)="back()"><i class="db-icon db-icon-menu-arrow"></i>{{'text_back' | dbText}}</div>
  </div>
  <div class="db-migrate-only__body">
    <div>
      <h2 class="mb10">Migrate to 10Web hosting <br/>to optimize your website</h2>
      <p class="db-migrate-only__subtitle" *ngIf="!currentSubscription?.boosterProClient">Our migration plugin will create a separate copy of the website and the live website won’t be affected.</p>
      <p class="db-migrate-only__subtitle" *ngIf="currentSubscription?.boosterProClient">Download and install our migration plugin to automatically create a copy of your website<br/>  on our hosting. You can test everything and point your domain afterwards.</p>

      <div class="db-migration-steps mt25">
        <div>
          <div class="db-migration-step-count mr10">
            <div> <p>1</p> </div>
          </div>
          <p class="db-migration-step-desc"> Download migration plugin ZIP </p>
        </div>
        <div class="mt15">
          <div class="db-migration-step-count mr10">
            <div> <p>2</p> </div>
          </div>
          <p class="db-migration-step-desc"> Install and activate the plugin </p>
        </div>
        <div class="mt15">
          <div class="db-migration-step-count mr10">
            <div> <p>3</p> </div>
          </div>
          <p class="db-migration-step-desc" *ngIf="!currentSubscription?.boosterProClient"> Get the fully optimized website on 10Web hosting </p>
          <p class="db-migration-step-desc" *ngIf="currentSubscription?.boosterProClient"> Improve your website's hosting performance </p>
        </div>
      </div>
    </div>
    <div  [ngClass]="{'mt20': !!isMobile}">
      <div class="db-security-box">
        <div class="db-security-box__icon">
          <i class="db-icon db-icon-security"></i>
        </div>
        <div>
          <b> 100,000 websites have already been securely copied<br/> to 10Web with our migration plugin.</b>
          <p> Installation of the plugin won’t<br class="ds-hide-desktop"> affect your live website.</p>
        </div>
      </div>
      <div class="db-migrate-only__btns mt30" [ngClass]="{'flex-end': currentSubscription?.boosterProClient || currentSubscription?.isDedicatedVM || currentSubscription?.apiResellerPro}">
        @if (hostingsLimit && !currentSubscription?.boosterProClient && !currentSubscription?.isDedicatedVM && !currentSubscription?.apiResellerPro) {
          <div>
            <p class="db-add-website__domains-count-title">Websites<span *ngIf="isMobile">: </span> </p>
            <p class="db-add-website__domains-count-desc">{{ hostedWebsitesCount }} of {{ hostingsLimit }}</p>
          </div>
        }
        <a class="ds-btn ds-btn-black" href="{{managerLink}}" (click)="downloadPlugin()" download>
          <span>{{'text_download' | dbText}}</span>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="db-migrate-website__image-section">
  <img src="assets/images/migration/migrate_website_black_bg.png" alt=""/>
</div>
